document.addEventListener('DOMContentLoaded', () => {

  // Select the parent wrapper
  const parentWrapper = document.querySelector('.product-app-parent-wrapper');
  if (!parentWrapper) return; // Exit if wrapper not found

  // MutationObserver to watch for easysearch-block-container inside parentWrapper
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1 && node.classList.contains('easysearch-block-container')) {
          parentWrapper.classList.add('loaded');

          const headerHolder = node.querySelector('.easysearch-header-holder');
          if (headerHolder) headerHolder.textContent = 'Find your key:';
        }
      }
    }
  });

  observer.observe(parentWrapper, {
    childList: true // Only observe direct children of parentWrapper
  });

  // Check immediately in case the element already exists
  const existingBlock = parentWrapper.querySelector('.easysearch-block-container');
  if (existingBlock) {
    parentWrapper.classList.add('loaded');

    const headerHolder = existingBlock.querySelector('.easysearch-header-holder');
    if (headerHolder) headerHolder.textContent = 'Find your key:';
  }

  // Trigger click behavior
  const trigger = document.getElementById('header__find-your-key');
  if (trigger) {
    trigger.addEventListener('click', () => {
      // Toggle max-height
      const holder = parentWrapper.querySelector('.easysearch-block-container .easysearch-main-holder .easysearch-holder');
      if (holder) {
        holder.style.maxHeight = holder.style.maxHeight === '100%' ? '0' : '100%';
      }

      // Toggle display
      const block = parentWrapper.querySelector('.product-app-block');
      if (block) block.style.display = block.style.display === 'block' ? 'none' : 'block';

      // Toggle pointer events
      const easysearchContainer = parentWrapper.querySelector('.easysearch-container .easysearch-header-holder');
      if (easysearchContainer) {
        const isDisabled = easysearchContainer.style.pointerEvents === 'none';
        easysearchContainer.style.pointerEvents = isDisabled ? 'auto' : 'none';
      }
      
    });
  }

});
